module.exports = __webpack_public_path__ + "img/amplitude.7f742417.jpg";